<template>
    <div>
        <div v-if="view==='direct'">
            <div>
                <div class="wizard" v-if="!skipped && (room.status==='stopped' || room.status==='prepared' || room.status==='starting')">
                    <div v-if="room.status==='stopped'">
                        <div class="big-button">
                            <div class="instructions">
                                <i class="icon fas fa-door-open"></i>
                                <h3>Prepare Room</h3>
                                <div>Just before introducing participants into the room it should be prepared.  This starts the ambient audio, lights and display screens.</div>
                            </div>

                            <b-button variant="primary" size="lg" block @click="prepareRoom()">Prepare Room</b-button>
                            <b-button variant="link" size="sm" @click="skipped=true" class="other"><i class="far fa-times"></i> Skip Setup</b-button>
                        </div>
                    </div>
                    <div v-if="room.status==='prepared'">
                        <div class="big-button">
                            <div class="instructions">
                                <i class="icon fas fa-play-circle"></i>
                                <h3>Start Room</h3>
                                <div>After you have introduced participants into the room you are ready to go.  Start the room to set off a series of events and start the room timer.</div>
                            </div>

                            <b-button variant="primary" size="lg" block @click="startRoom()">Start Room</b-button>
                            <b-button variant="link" size="sm" @click="skipped=true" class="other"><i class="far fa-times"></i> Skip Setup</b-button>
                        </div>
                    </div>
                    <div v-if="room.status==='starting'">
                        <div class="big-button">
                            <div class="instructions">
                                <i class="icon fas fa-play-circle"></i>
                                <h3>Please Wait</h3>
                                <div>The room is starting...</div>
                            </div>
                            <b-button variant="link" size="sm" @click="skipped=true" class="other"><i class="far fa-times"></i> Skip Setup</b-button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-for="group in buttonGroups">
                        <h2>{{group.title}}</h2>
                        <small-button v-for="button in group.buttons" :config="button" :key="button.title + button.type"></small-button>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="view==='assist'">

        </div>
        <div v-else-if="view==='help'">
            <h2>
                Help
            </h2>
        </div>
    </div>
</template>

<script>
    import SmallButton from '../../components/app/director/button.vue';

    export default {
        name: 'Kit1Director',
        components: {
            SmallButton
        },
        props: [
            'room','message','view'
        ],
        data: function() {
            let director = this;
            return {
                skipped: false,
                allSounds: false,
                allOnceOnly: false,
                allStopSounds: false,
                allScreens: false,

                buttonGroups: [
                    {
                        title: 'Atmosphere',
                        buttons: [
                            {
                                icon: 'fas fa-volume-up',
                                type: 'sound',
                                repeat: 'repeat',
                                title: 'Explosion<br>& Alarm',
                                subTitle: 'Sound effect of an explosion followed by an alarm.',
                                action: function() {
                                    director.playSound('explosion');
                                },
                                stop: function() {
                                    director.stopSound('explosion');
                                }
                            },
                            {
                                icon: 'fas fa-volume-up',
                                type: 'sound',
                                repeat: 'repeat',
                                title: 'Warning<br>Alarm',
                                subTitle: 'A simple alarm sound effect, repeated 3 times.',
                                action: function() {
                                    director.playSound('alarm');
                                },
                                stop: function() {
                                    director.stopSound('alarm');
                                }
                            },
                            {
                                icon: 'fas fa-bolt',
                                type: 'sound',
                                repeat: 'once',
                                title: 'Emergency<br>Power Restored',
                                subTitle: 'Voice stating that "Emergency Power Restored".',
                                action: function() {
                                    director.playSound('power');
                                },
                                stop: function() {
                                    director.stopSound('power');
                                }
                            },
                            {
                                icon: 'fas fa-music',
                                type: 'sound',
                                repeat: 'once',
                                title: 'Ambient<br>Sound Effects',
                                subTitle: 'Background sounds of ship engines and computer beeps.',
                                action: function() {
                                    director.playSound('ambient');
                                },
                                stop: function() {
                                    director.stopSound('ambient');
                                }
                            }
                        ]
                    },
                    {
                        title: 'Puzzles',
                        buttons: [
                            {
                                icon: 'fas fa-broadcast-tower',
                                type: 'puzzle',
                                repeat: 'repeat',
                                title: 'Incoming Message',
                                subTitle: 'A morse code encoded message. Repeat as needed.',
                                action: function() {
                                    director.playSound('morse');
                                },
                                stop: function() {
                                    director.stopSound('morse');
                                }
                            }
                        ]
                    },
                    {
                        title: 'Advanced Control',
                        buttons: [
                            {
                                icon: 'fas fa-door-open',
                                type: 'event',
                                repeat: 'once',
                                title: 'Prepare/Reset Room',
                                subTitle: 'Set Displays to "Welcome" and start "Ambient Sounds".',
                                action: function() {
                                    director.prepareRoom();
                                }
                            },
                            {
                                icon: 'fas fa-exclamation-triangle',
                                type: 'event',
                                repeat: 'once',
                                title: 'Start Room<br>Self Destruct',
                                subTitle: 'Start and announce a "Self Destruct" in 60 minutes.',
                                action: function() {
                                    director.startRoom();
                                }
                            },
                            {
                                icon: 'fas fa-skull',
                                type: 'event',
                                repeat: 'once',
                                title: 'Escape<br>Room Failed',
                                subTitle: 'The ship has exploded and participants failed to escape.',
                                action: function() {
                                    director.playSound('dead');
                                    director.setTime(0);
                                    director.setStatus('failed');
                                }
                            },
                            {
                                icon: 'fas fa-thumbs-up',
                                type: 'event',
                                repeat: 'once',
                                title: 'Escape<br>Room Success',
                                subTitle: 'Participants successfully escaped the room!',
                                action: function() {
                                    director.playSound('deactivated');
                                    director.setStatus('success');
                                }
                            },
                            {
                                icon: 'fas fa-hand-spock',
                                type: 'screen',
                                repeat: '',
                                title: 'Welcome<br>Screen',
                                subTitle: 'A welcome screen before the "Self Destruct".',
                                action: function() {
                                    director.changeScreen('welcome');
                                }
                            },
                            {
                                icon: 'fas fa-tv',
                                type: 'screen',
                                repeat: '',
                                title: 'Black<br>Screen',
                                subTitle: 'A simple black screen to prepare or "turn off" a Display.',
                                action: function() {
                                    director.changeScreen('black');
                                }
                            },
                            {
                                icon: 'fas fa-stopwatch',
                                type: 'screen',
                                repeat: '',
                                title: 'Self Destruct Countdown',
                                subTitle: 'Countdown timer screen for "Self Destruct Sequence".',
                                action: function() {
                                    director.changeScreen('countdown');
                                }
                            },
                            {
                                icon: 'fas fa-skull',
                                type: 'screen',
                                repeat: '',
                                title: 'Escape<br>Room Failed',
                                subTitle: 'The ship has exploded and participants failed to escape.',
                                action: function() {
                                    director.changeScreen('dead');
                                }
                            },
                            {
                                icon: 'fas fa-thumbs-up',
                                type: 'screen',
                                repeat: '',
                                title: 'Escape<br>Room Success',
                                subTitle: 'Participants successfully escaped the room!',
                                action: function() {
                                    director.changeScreen('deactivated');
                                }
                            }
                        ]
                    }
                ]
            }
        },
        methods: {
            prepareRoom: function() {
                this.playSound('prepare');
                this.setStatus('prepared');
            },
            startRoom: function() {
                let that = this;
                this.setStatus('starting');
                this.playSound('destruct');
                setTimeout(function() {
                    that.setTime(3600000);
                    that.setStatus('running');
                }, 26000);
            },
            playSound: function(sound) {
                this.$emit('sound', 'play', sound);
            },
            stopSound: function(sound) {
                this.$emit('sound', 'stop', sound);
            },
            changeScreen: function(screen) {
                this.$emit('screen', screen);
            },
            setTime: function(time) {
                this.$emit('timer', time);
            },
            setStatus: function(status) {
                this.$emit('status', status);
            }
        },
        watch: {
            message: function (payload) {
                if (payload.cmd === 'message' || payload.cmd === 'broadcast') {
                    let msg = payload.data;
                    switch (msg.cmd) {
                        case 'play':
                            if (msg.data.sound === 'deactivated') {
                                this.room.status = 'success';
                                this.setStatus('success');
                            }
                            break;
                    }
                }
            }
        },
    }

</script>

<style lang="scss" scoped>
    h2 {
        font-family: 'Sumana', serif;
        font-size: 20px;
        margin: 15px 20px 0 20px;
    }

    .wizard {
        text-align: center;
    }

    .big-button {
        margin: 35px 20px 20px;
        text-align: center;
        width: 100%;
        max-width: 400px;
        background: rgba(0,0,0,0.7);
        display: inline-block;
        padding: 35px 35px 20px;
        border: 1px solid rgba(255,255,255,0.3);

        i.icon {
            font-size: 60px;
        }

        h3 {
            margin: 20px 0 25px 0;
        }

        .instructions {
            margin-bottom: 35px;
            padding-bottom: 20px;
            border-bottom: 1px solid rgba(255,255,255,0.3);

            >div {
                font-size: 13px;
                color: #bbb;
                margin: 10px 0;
            }
        }

        button {
            i {
                margin-right: 8px;
            }

            &.action {
                background: #e45114;
                font-size: 18px;
                padding: 15px 20px;
            }

            &.other {
                margin-top: 25px;
                font-weight: normal;
                color: #666 !important;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/kits/1/director.vue